
import { genQueryJsonStr } from '@/utils/querySchema'

export default function () {
  function goPage(row, query = {}) {
    const path = '/workbench/entOrder/list'
    this.$router.push(
      `${path}?query=${genQueryJsonStr(query)}`,
    )
  }
  function renderContent(row, rowKey, query) {
    return this.$createElement('span', {
      class: 'item-active',
      on: {
        click: () => { goPage.call(this, row, query) },
      },
    }, rowKey)
  }
  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'mainAll',
      columnProps: {
        label: '全部主订单数',
        prop: 'mainAll',
      },
      render: ({ row }) => {
        const query = {
          tab: 'primary',
        }
        return renderContent.call(this, row, row.mainAll, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subAll',
      columnProps: {
        label: '全部子订单数',
        prop: 'subAll',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
        }
        return renderContent.call(this, row, row.subAll, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subToProcess',
      columnProps: {
        label: '待履约子订单数',
        prop: 'subToProcess',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          children: [{
            tab: '1',
          }],
        }
        return renderContent.call(this, row, row.subToProcess, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subInProcess',
      columnProps: {
        label: '履约中子订单数',
        prop: 'subInProcess',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          children: [{
            tab: '2',
          }],
        }
        return renderContent.call(this, row, row.subInProcess, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subInAccount',
      columnProps: {
        label: '退车核算子订单数',
        prop: 'subInAccount',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          children: [{
            tab: '3',
          }],
        }
        return renderContent.call(this, row, row.subInAccount, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'subClosed',
      columnProps: {
        label: '已关闭子订单数',
        prop: 'subClosed',
      },
      render: ({ row }) => {
        const query = {
          tab: 'child',
          children: [{
            tab: '4',
          }],
        }
        return renderContent.call(this, row, row.subClosed, query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'mainClosed',
      columnProps: {
        label: '已关闭主订单数',
        prop: 'mainClosed',
      },
      columnHeaderTooltip: '',
    },
  ]
  return {
    columns,
  }
}

